import {Link, useHistory} from 'react-router-dom';
import Flex from './ui/Flex';
import {Card} from './ui/Card';
import AuthForm from './auth/AuthForm';
import {CTAButton} from './ui/Button';
import {useSelector} from 'react-redux';
import {H1} from './ui/Header';
import FadeSpinner from './ui/FadeSpinner';

export default function Login({redirect}) {
  const history = useHistory()
  const user = useSelector(state => state.user.currentUser)
  const status = useSelector(state => state.user.status.signIn)

  const handleSignIn = () => {
    history.push(redirect)
  }

  if(user) {
    history.push(redirect)
  }

  if(status === 'pending') {
    return (
      <>
        <H1>Logging in...</H1>
        <FadeSpinner/>
      </>
    )
  }

  return (
    <Flex alignItems='center' justifyContent='center' flexDirection='column'>
      <Card maxWidth='800px'>
        <AuthForm onSignIn={handleSignIn}/>
      </Card>
      <Flex style={{marginLeft: '1em'}} justifyContent='center'>
        <Link to='/'><CTAButton>Back to the Wandering Eye</CTAButton></Link>
      </Flex>
    </Flex>
  )
}